import React from "react";
import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, Clock, Facebook, Instagram } from "lucide-react";
import { companyInfo, getServices } from "../mock";
import { useTranslation } from "../hooks/useTranslation";
import { useLanguage } from "../contexts/LanguageContext";

const Footer = () => {
  const { t } = useTranslation();
  const { language } = useLanguage();
  
  const services = getServices(language);
  
  return (
    <footer className="bg-slate-800 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          
          {/* Company Info */}
          <div className="lg:col-span-1">
            <div className="flex items-center space-x-3 mb-4">
              <img 
                src="https://customer-assets.emergentagent.com/job_aymorenov-catalog/artifacts/bkaifu5k_logo.png"
                alt="AYMORENOV Logo"
                className="h-12 w-auto object-contain"
              />
            </div>
            <p className="text-slate-300 text-sm mb-4">
              {t('footer.tagline')}
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.facebook.com/search/top/?q=aymorenov%20construction%20inc"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white cursor-pointer transition-colors"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/aymorenov_construction_inc_"
                target="_blank"
                rel="noopener noreferrer"
                className="text-slate-400 hover:text-white cursor-pointer transition-colors"
              >
                <Instagram className="w-5 h-5" />
              </a>
              
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-4">{t('footer.quickLinks')}</h4>
            <ul className="space-y-2">
              <li><Link to="/" className="text-slate-300 hover:text-white transition-colors">{t('nav.home')}</Link></li>
              <li><Link to="/about" className="text-slate-300 hover:text-white transition-colors">{t('nav.about')}</Link></li>
              <li><Link to="/contact" className="text-slate-300 hover:text-white transition-colors">{t('nav.contact')}</Link></li>
              <li><Link to="/quote" className="text-slate-300 hover:text-white transition-colors">{t('nav.quote')}</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-4">{t('footer.ourServices')}</h4>
            <ul className="space-y-2 text-slate-300">
              {services.map((service, index) => (
                <li key={index}>{service.title}</li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-4">{t('footer.contact')}</h4>
            <div className="space-y-3">
              <div className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-red-400 mt-0.5 flex-shrink-0" />
                <p className="text-slate-300 text-sm">{t('contact.address')}</p>
              </div>
              <div className="flex items-center space-x-3">
                <Phone className="w-5 h-5 text-red-400 flex-shrink-0" />
                <p className="text-slate-300 text-sm">{t('contact.phone')}</p>
              </div>
              <div className="flex items-center space-x-3">
                <Mail className="w-5 h-5 text-red-400 flex-shrink-0" />
                <p className="text-slate-300 text-sm">{t('contact.email')}</p>
              </div>
              <div className="flex items-center space-x-3">
                <Clock className="w-5 h-5 text-red-400 flex-shrink-0" />
                <p className="text-slate-300 text-sm">{t('header.hours')}</p>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-700 mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-slate-400 text-sm">
              {t('footer.copyright')}
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;